<template>
  <div class="gtin" v-if="selectedGtin">
    <span>{{ selectedGtin }}</span>
    <template v-if="additionalAmount > 0">
      <v-tooltip top >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            text
            elevation="0"
            small
            plain
            class="gtin__btn"
            v-bind="attrs"
            v-on="on"
          >
          (+{{ additionalAmount }})
          </v-btn>
        </template>
      <span>{{ additionalGtins.join(', ') }}</span>
    </v-tooltip>
       
    </template>
    
  </div>
</template>

<script>
import {cloneDeep} from 'lodash';

  export default {
    name: 'ItemGtins',
    components: {},
    props:{
      gtins:{
        type: Array
      }
    },
    data(){
      return {
        list: []
      };
    },
    created(){
      this.init();
    },
    watch:{
    },
    computed:{
      selectedGtin(){
        if(!this.list || !this.list.length) return '';
        return this.list[0];
      },
      additionalGtins(){
        if(!this.list || this.list.length <= 1) return [];
        return this.list.filter((gtin) => gtin !== this.selectedGtin);
      },
      additionalAmount(){
        return this.additionalGtins.length;
      }
    },
    methods:{
      init(){
        this.list = cloneDeep(this.gtins);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .gtin{
    display: flex;
    align-items: center;
    color: #666666 !important;
        font-family: Arial, sans-serif!important;
        font-weight: 400!important;
        font-size: 14px!important;
        line-height: 16.1px!important;
    &__btn{
      &::v-deep.v-btn{
        padding: 0;
        min-width: 30px;
      }
      &::v-deep .v-btn__content{
        color: #666666 !important;
        font-family: Arial, sans-serif!important;
        font-weight: 400!important;
        font-size: 14px!important;
        opacity: 1!important;
        line-height: 16.1px!important;
      }
    }
  }
</style> 
